/**
 * GiftGo — Preloader with step-based progress.
 *
 * Progress bar advances as each bootstrap stage completes,
 * giving the user real feedback instead of a fake animation.
 */

class Preloader {
  constructor() {
    this.element = null;
    this._bar = null;
    this._currentProgress = 0;
  }

  /**
   * Show preloader in the target container.
   * @param {HTMLElement} container — parent DOM element
   */
  show(container) {
    if (this.element) return;

    const el = document.createElement('div');
    el.id = 'spa-preloader';
    el.className = 'preloader';
    el.innerHTML = `
      <div class="dice-loader">
        <tgs-player src="/static/preloader.tgs" autoplay class="tgs-small"></tgs-player>
      </div>
      <div class="preloader-progress">
        <div class="preloader-progress-bar spa-preloader-bar"></div>
      </div>
    `;

    container.appendChild(el);
    this.element = el;
    this._bar = el.querySelector('.spa-preloader-bar');
    this._currentProgress = 0;

    // Small initial bump so the user sees immediate movement
    requestAnimationFrame(() => this.setProgress(5));
  }

  /**
   * Set progress bar to a specific percentage (0–100).
   * Only moves forward — ignores values less than current progress.
   * @param {number} percent — target progress (0–100)
   */
  setProgress(percent) {
    if (!this._bar) return;
    const clamped = Math.min(100, Math.max(0, percent));
    if (clamped <= this._currentProgress) return; // Only move forward
    this._currentProgress = clamped;
    this._bar.style.width = `${clamped}%`;
  }

  /**
   * Complete progress to 100% and fade out.
   */
  hide() {
    if (!this.element) return;

    this.setProgress(100);
    this.element.classList.add('preloader-hiding');

    setTimeout(() => {
      if (this.element) {
        this.element.remove();
        this.element = null;
        this._bar = null;
      }
    }, 400);
  }
}

export default Preloader;
